<div
  class="flex items-center w-full rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 hover:border-slate-300"
>
  <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
    <i class="bi bi-search text-sm"></i>
  </span>
  <input
    #inputBusqueda
    type="text"
    [(ngModel)]="valor"
    [placeholder]="placeholder()"
    (keydown.enter)="emitirBusqueda()"
    class="w-full border-0 bg-transparent py-2 pr-3 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-0"
  />
  @if (valor()) {
    <button
      type="button"
      (click)="valor.set(''); emitirBusqueda()"
      class="mr-1 shrink-0 rounded-md p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors"
      aria-label="Limpiar búsqueda"
    >
      <i class="bi bi-x text-sm"></i>
    </button>
  }
</div>
